import React, { useState } from "react";
import { Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";

const DeleteBlogModal = ({ preview, previewHandler, successHandler, selectedBlog }) => {
  const [deleteLoader, setdeleteLoader] = useState(false);
  const { http } = global.services;

  const deleteFileHandler = () => {
    setdeleteLoader(true);
    http
      .delete(`admin-blog/${selectedBlog.id}`)
      .finally(() => setdeleteLoader(false))
      .then(() => {
        toast.success("Blog deleted successfully");
        successHandler(selectedBlog.id);
        previewHandler();
      })
      .catch(({ data }) => toast.error(data?.error ?? "Something went wrong"));
  };

  return (
    <Modal
      visible={preview}
      centered
      className="delete-column-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Delete Blog</h2>
      <p>Are you sure you want to delete {selectedBlog?.title}?</p>
      <div className="action-box">
        <button onClick={previewHandler}>Cancel</button>
        <button className="delete" onClick={deleteFileHandler}>
          {deleteLoader ? <BeatLoader size={8} color="#fff" /> : "Delete"}
        </button>
      </div>
    </Modal>
  );
};

export default DeleteBlogModal;
